export class LoadCollegeData {

    public address1: string;
    public address2: string;
    public address3: string;
    public pincode: string;
    public phonenumber: string;
    public examdate: string;
    public studentno: number;

    constructor() {
        this.address1 = '';
        this.address2 = '';
        this.address3 = '';
        this.pincode = '';
        this.phonenumber = '';
        this.examdate = '';
        this.studentno = 0;
    }
}
